module.exports = __webpack_public_path__ + "img/beer_id-98.37e0b62e.png";